import React, { useMemo } from 'react'

const Stages = {
  0: 'Building app',
  1: 'Delivering app',
  2: 'Initializing app',
}
const Loading = ({ stage = 0 }) => {
  const mSpinner = useMemo(
    () => <div className={'spinner'} style={{ marginBottom: 20 }}>
    </div>, [])
  return (
    <div>
      {mSpinner}
      <div className={'mx-auto'} style={{ width: 'max-content' }}>
        <h3>{Stages[stage]}</h3>
      </div>
    </div>
  )
}

export default Loading
